import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      {/* Header */}
      <div className="bg-[#0A0A0A] border-b border-[#1a1a1a]">
        <div className="max-w-4xl mx-auto px-4 py-6 flex items-center gap-4">
          <Link to="/" className="text-[#EFFF00] hover:text-[#EFFF00]/80 transition-colors" data-testid="mentions-back-btn">
            <ArrowLeft className="w-6 h-6" />
          </Link>
          <h1 className="text-2xl font-bold text-[#EFFF00]">PUB PRO</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8 text-white" data-testid="mentions-title">Mentions Légales</h1>
        
        <div className="space-y-8 text-[#D4D4D4] leading-relaxed">
          {/* Éditeur */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Éditeur du site</h2>
            <p>Le site simulation-enseigne.fr est édité par :</p>
            <div className="bg-[#111] border border-[#262626] rounded-xl p-5 mt-3">
              <p><strong className="text-white">PUB PRO</strong></p>
              <p>Fabricant d'enseignes lumineuses</p>
              <p>La Courneuve, 93120</p>
              <p>Île-de-France, France</p>
              <p>Téléphone : 06 43 69 36 88</p>
              <p>Email : pubpro.france@gmail.com</p>
            </div>
          </section>

          {/* Hébergeur */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. Hébergeur</h2>
            <p>Le site est hébergé par Emergent Labs.</p>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. Propriété intellectuelle</h2>
            <p>L'ensemble du contenu du site (textes, images, vidéos, logos, graphismes) est la propriété exclusive de PUB PRO ou de ses partenaires. Toute reproduction, représentation, modification ou exploitation non autorisée est interdite.</p>
          </section>

          {/* Données personnelles */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Protection des données personnelles (RGPD)</h2>
            <p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants sur vos données :</p>
            <ul className="list-disc list-inside mt-3 space-y-2">
              <li>Droit d'accès à vos données personnelles</li>
              <li>Droit de rectification des données inexactes</li>
              <li>Droit à l'effacement (droit à l'oubli)</li>
              <li>Droit à la portabilité de vos données</li>
              <li>Droit d'opposition au traitement</li>
            </ul>
            <p className="mt-3">Les données collectées via le formulaire de simulation (nom, email, téléphone, ville, description du projet) sont utilisées uniquement pour répondre à votre demande et vous recontacter. Elles ne sont jamais vendues à des tiers.</p>
            <p className="mt-2">Pour exercer vos droits, contactez-nous à : pubpro.france@gmail.com</p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. Cookies</h2>
            <p>Le site utilise des cookies techniques nécessaires à son fonctionnement et des cookies analytiques pour améliorer votre expérience. Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.</p>
          </section>

          {/* Responsabilité */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. Limitation de responsabilité</h2>
            <p>PUB PRO s'efforce de fournir des informations exactes et à jour sur ce site. Toutefois, nous ne pouvons garantir l'exhaustivité ou l'exactitude de toutes les informations présentées. Les prix indiqués sont donnés à titre indicatif et ne constituent pas une offre contractuelle.</p>
          </section>

          {/* CGV */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. Conditions Générales de Vente</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-white">7.1 Devis et commande</h3>
                <p>Tout projet fait l'objet d'un devis gratuit et personnalisé. La commande est confirmée après acceptation du devis et versement d'un acompte de 40%.</p>
              </div>
              <div>
                <h3 className="font-semibold text-white">7.2 Délais</h3>
                <p>Le délai de fabrication est de 2 à 4 semaines à compter de la validation du BAT (Bon À Tirer). Les délais d'installation sont communiqués au cas par cas.</p>
              </div>
              <div>
                <h3 className="font-semibold text-white">7.3 Garanties</h3>
                <p>PUB PRO offre une garantie décennale sur la structure de l'enseigne et une garantie de 2 à 10 ans sur les composants LED selon le modèle choisi.</p>
              </div>
              <div>
                <h3 className="font-semibold text-white">7.4 Paiement</h3>
                <p>Modes de paiement acceptés : virement bancaire, chèque, carte bancaire. Paiement en 3 fois sans frais disponible pour les commandes supérieures à 2 000€ HT.</p>
              </div>
            </div>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. Droit applicable</h2>
            <p>Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux compétents seront ceux de Bobigny (93).</p>
          </section>
        </div>

        {/* Footer link back */}
        <div className="mt-12 pt-8 border-t border-[#262626]">
          <Link to="/" className="text-[#EFFF00] hover:underline font-medium" data-testid="mentions-back-link">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
